@if (!advancedOgcFilters) {
  <igo-ogc-filter-selection
    igoListItem
    [refreshFilters]="refreshFunc"
    [datasource]="datasource()"
    [map]="map()"
    [currentFilter]="currentFilter"
  />
}

@if (
  advancedOgcFilters && datasource().options.ogcFilters.editable;
  as currentFilter
) {
  @for (
    currentFilter of datasource().options.ogcFilters.interfaceOgcFilters;
    track currentFilter
  ) {
    <igo-ogc-filter-form
      [currentFilter]="currentFilter"
      [refreshFilters]="refreshFunc"
      [datasource]="datasource()"
      [map]="map()"
    />
  }
}
